import { createAction } from '@reduxjs/toolkit';
import { INotificationsState } from '@store/notifications/types';
import { IPushNotificationSchedulePreference } from 'lingopractices-models';

export class UpdateNotificationScheduleSuccess {
  static get action() {
    return createAction<IPushNotificationSchedulePreference>(
      'notifications/UPDATE_NOTIFICATION_SCHEDULE_SUCCESS',
    );
  }

  static get reducer() {
    return (
      draft: INotificationsState,
      { payload }: ReturnType<typeof UpdateNotificationScheduleSuccess.action>,
    ) => {
      draft.notificationSchedule = payload;
      draft.requests.updateNotificationSchedulePending = false;

      return draft;
    };
  }
}
